import { DecimalPipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { MessageModule } from 'primeng/message';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';

import {
  dailyResultBand,
  dailyResultSeverity,
  DailyResultV1,
  scoringCategoryName,
  utcStamp
} from '@core/models/daily-results';

@Component({
  selector: 'app-daily-result-detail',
  imports: [DecimalPipe, MessageModule, TableModule, TagModule],
  templateUrl: './daily-result-detail.html',
  styleUrl: './daily-result-detail.scss'
})
export class DailyResultDetail {
  readonly result = input.required<DailyResultV1>();

  // Off where the summary is already on screen, as it is in the row a day expands from.
  readonly showSummary = input(true);

  protected readonly statusSeverity = computed(() => dailyResultSeverity(this.result().status));
  protected readonly band = computed(() => dailyResultBand(this.result()));

  protected readonly collapsedRampNutrients = computed(() =>
    (this.result().overageRampCollapsedNutrientIds ?? []).join(', ')
  );

  protected readonly scoringCategoryName = scoringCategoryName;
  protected readonly utcStamp = utcStamp;
}
